// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290504/js/" + chunkId + "." + {"44":"b2805a70","225":"c795d652","481":"4282ea55","486":"266cfb42","770":"d920b100"}[chunkId] + ".0.5056319967496798.chunk.js";
};